function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["enabled", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DismissableLayer as RadixDismissableLayer } from '@radix-ui/react-dismissable-layer';
import { forwardRef, useRef } from 'react';
import { createPortal } from 'react-dom';

/**
 * The entire point of this component is to get around the fact that radix's
 * `DismissableLayer` does not have an `enabled` prop.  If radix's
 * `DismissableLayer` had an `enabled` prop, we wouldn't need this trickery
 *
 * Instead of an `enabled` prop, radix's `DismissableLayer` forces you to
 * unmount and remount the component to enable and disable it.  For example:
 * ```
 * {enabled ? <DismissableLayer><ul></ul></DismissableLayer> : <ul></ul>}
 * ```
 *
 * The problem with this is that it causes the `ul` to be unmounted and
 * remounted, because changing parents in react always causes an
 * unmount/remount.  This surprisingly causes issues on mobile as explained
 * here: https://applyboard.atlassian.net/browse/UIE-2743
 *
 * This component wraps radix's DismissableLayer and allows you to enable and
 * disable it **without unmounting and remounting the children**.  The technical
 * term for this is called "reparenting" and there's not an easy way to do this
 * in react
 *
 * However, there is a workaround:
 * 1. Create a non-react-managed "childrenContainer" div element using `document.createElement`
 * 2. Add the react children to the "childrenContainer"" element using `createPortal`
 * 3. Move the "childrenContainer" element to the DismissableLayer when it's enabled using `replaceChildren`
 * 4. Move the "childrenContainer" element outside the DismissableLayer when it's disabled using `replaceChildren`
 *
 * This way, the children are never unmounted and remounted from react's
 * perspective.  The DOM node containing the children is simply moved around
 * using DOM apis
 *
 * This approach is touched on in this github comment: https://github.com/facebook/react/issues/3965#issuecomment-106205133
 *
 * and also explained in the 1st bullet point here: https://github.com/reactjs/rfcs/pull/34#issuecomment-901466409
 */
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var DismissableLayer = /*#__PURE__*/forwardRef(function DismissableLayer(_ref, ref) {
  var enabled = _ref.enabled,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var childrenContainerRef = useRef(null);
  if (!childrenContainerRef.current) {
    var _globalThis$document;
    childrenContainerRef.current = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.createElement('div');
  }
  if (enabled && !childrenContainerRef.current) {
    throw new Error('[DismissableLayer]: Can not enable the layer on the server');
  }
  return _jsxs(_Fragment, {
    children: [enabled && _jsx(RadixDismissableLayer, _objectSpread(_objectSpread({
      ref: ref
    }, props), {}, {
      children: _jsx("div", {
        ref: function ref(divEl) {
          if (divEl && childrenContainerRef.current) {
            var alreadyHasEl = Array.from(divEl.childNodes || []).some(function (node) {
              return node === childrenContainerRef.current;
            });
            if (!alreadyHasEl) {
              divEl.innerHTML = '';
              divEl.appendChild(childrenContainerRef.current);
            }
          }
        }
      })
    })), !enabled && _jsx("div", {
      ref: ref,
      children: childrenContainerRef.current ? _jsx("div", {
        ref: function ref(divEl) {
          if (divEl && childrenContainerRef.current) {
            var alreadyHasEl = Array.from(divEl.childNodes || []).some(function (node) {
              return node === childrenContainerRef.current;
            });
            if (!alreadyHasEl) {
              divEl.innerHTML = '';
              divEl.appendChild(childrenContainerRef.current);
            }
          }
        }
      }) : _jsx("div", {
        children: children
      })
    }), childrenContainerRef.current && /*#__PURE__*/createPortal(children, childrenContainerRef.current)]
  });
});